<template>
  <v-container class="fill-height d-flex align-center justify-center" style="min-height: 500px;">
    <v-slide-y-transition>
      <div v-if="show" class="w-100 text-center">
        <h1 class="mb-2 font-weight-bold" style="font-size:2.2rem;color:#333;">{{ $t('rollOffWizard.loading.title') }}</h1>
        <p class="mb-0" style="font-size:1.1rem;color:#444;">{{ $t('rollOffWizard.loading.subtitle') }}</p>
      </div>
    </v-slide-y-transition>
  </v-container>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import { useRollOffWizardStore } from '@/store/rollOffWizard'
const store = useRollOffWizardStore()
const show = ref(false)

onMounted(() => {
  // Show the content with slide animation
  show.value = true

  setTimeout(() => {
    store.nextView()
  }, 2000)
})
</script>